export default __webpack_public_path__ + "locales/ru/PortalUnavailable.json?hash=91e91131ca6cd1eedc51fcc831c7eeb7";